var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15521_76154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 3.33398C17.5457 3.33398 18.2655 4.01388 18.3291 4.87627L18.3337 5.00065V15.0007C18.3337 15.8793 17.6538 16.5991 16.7914 16.6627L16.667 16.6673H3.33366C2.45502 16.6673 1.73519 15.9874 1.67156 15.125L1.66699 15.0007V5.00065C1.66699 4.12202 2.34689 3.40218 3.20927 3.33856L3.33366 3.33398H16.667ZM16.667 6.17918L10.8842 11.962C10.396 12.4502 9.60458 12.4502 9.11641 11.962L3.33366 6.17918V15.0007H16.667V6.17918ZM15.4885 5.00065H4.51207L10.0003 10.4889L15.4885 5.00065Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15521_76154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.cbd11dc175f86fa52a4d36766a19097a.svg";
export { ForwardRef as ReactComponent };